import { render, staticRenderFns } from "./WarehouseScreenOffers.vue?vue&type=template&id=524d4d56"
import script from "./WarehouseScreenOffers.vue?vue&type=script&lang=js"
export * from "./WarehouseScreenOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports